import { Role } from '@/api'
import { useRights } from '@/hooks/use-rights'

/** Rôles autorisés à voir et modifier la section Organisation dans Paramètres (aligné sur la sidenav Management Console). */
export const ORG_SETTINGS_ROLES: Role[] = [
  Role.Superadmin,
  Role.Admin,
  Role.Manager,
]

/** Abonnement + Facturation : admin org / superadmin uniquement. */
export const BILLING_SETTINGS_ROLES: Role[] = [
  Role.Superadmin,
  Role.Admin,
]

export function canAccessOrgSettings(role: Role | undefined): boolean {
  return role != null && ORG_SETTINGS_ROLES.includes(role)
}

export function canAccessBillingSettings(role: Role | undefined): boolean {
  return role != null && BILLING_SETTINGS_ROLES.includes(role)
}

/**
 * Voir les paramètres de l'organisation et sa facturation : les rôles d'avant, ou en mode actif les droits du
 * membre (TEC-1677). Les paramètres se lisent quelque part ; la facturation, sur la racine de l'organisation.
 */
export function useSettingsAccess(role: Role | undefined): { org: boolean; billing: boolean } {
  const rights = useRights()
  return {
    org: rights.can('general_settings.read', null, canAccessOrgSettings(role)),
    billing: rights.can('billing.read', rights.rootGroupId, canAccessBillingSettings(role)),
  }
}
